import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../common/button/Button';
import Spinner from '../../../common/Spinner/Spinner';


const JournalistsPage = ({ journalistsData, isLoadingData, getJournalistsData }) => {
    /*
    const [showOldJournalists, setShowOldJournalists] = useState(false);
    */

    useEffect(() => {
        animateScrollTo(0, { speed: 700 });

        if (journalistsData.length === 0) {
            getJournalistsData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className="sectionJournalist">
            <header className="header">
                <h1>Conheça a nossa equipe de jornalismo</h1>
            </header>

            <div className="journalistsContainer">
                {
                    journalistsData.length === 0 && isLoadingData
                        ? <Spinner />
                        :
                        <React.Fragment>
                            <div className="tw-justify-center tw-m-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                                {journalistsData.reduce((res, journalist) => {
                                    if (journalist.isActive) {
                                        res.push((
                                            <div key={`jornalist-${journalist.slug}`} className="blockContainer tw-border">
                                                <div className="journalistBlock">
                                                    <div className="journalistImage">
                                                        <img src={`https://a1media.antena1.com.br/image/journalists/300x375/${journalist.imageFile}`} alt={`Imagem de ${journalist.name}`} width="100%" />
                                                    </div>
                                                    <Button className="journalistGradientContainer" title={`Continue lendo sobre ${journalist.name}`} to={`/jornalistas/${journalist.slug}`}>
                                                        <h6 className="journalistName tw-pr-2">
                                                            {journalist.name}
                                                        </h6>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </Button>

                                                </div>
                                            </div>));
                                    }

                                    return res;
                                }, [])}
                            </div>
                            {/*
                            <hr />
                            <div className="oldJournalistContainer">
                                <Button
                                    title="Conheça nossa antiga equipe"
                                    onClick={() => setShowOldJournalists((currentShowOldJournalists) => !currentShowOldJournalists)}
                                >
                                    <span>
                                        <p className={showOldJournalists ? 'buttonClicked' : ''}>Conheça os jornalistas que já fizeram parte do time </p>
                                    </span>
                                </Button>
                            </div>
                            { showOldJournalists &&
                            <div className="journalistsList">
                                {journalistsData.toJS().reduce((res, journalist) => {
                                    if (!journalist.isActive) {
                                        res.push((
                                            <div key={`jornalist-${journalist.slug}`} className="blockContainer">
                                                <div className="journalistBlock">
                                                    <div className="journalistImage">
                                                        <img src={`https://a1media.antena1.com.br/image/journalists/145x145/${journalist.imageFile}`} alt={`Imagem de ${journalist.name}`} />
                                                    </div>
                                                    <h6 className="journalistName">
                                                        {journalist.name}
                                                    </h6>
                                                    <p>
                                                        {journalist.excerpt}
                                                    </p>
                                                    <Button className="toJournalist" title={`Continue lendo sobre ${journalist.name}`} to={`/jornalistas/${journalist.slug}`}>Veja mais</Button>
                                                </div>
                                            </div>));
                                    }

                                    return res;
                                }, [])}
                            </div>}
                            */}

                        </React.Fragment>
                }
            </div>
        </section>
    );
};

JournalistsPage.propTypes = exact({
    journalistsData: PropTypes.object,
    getJournalistsData: PropTypes.func.isRequired,
    isLoadingData: PropTypes.bool,
});

export default JournalistsPage;
